import { combineReducers } from 'redux';
import builderReducer from './builderReducer';

export default combineReducers({
    builder: builderReducer
})